module.exports = __webpack_public_path__ + "static/product1_2-4b9c3015d1b337f4762cebf4d9e3629b.jpg";